import React, { useState, useCallback } from 'react';
import { Genre } from './genre';
import { Content } from './content';
import { Footer } from './footer';
import spinner from '../../assests/images/spinner.gif';
import { IMainContentProps } from './mainContent.types';

export const MainContent = (props: IMainContentProps) => {

  const { getSongData, isLoading } = props;

  const [filter, selectFilter] = useState('');
  const [filterCount, setFilterCount] = useState(0);
  const [showGenre, setShowGenre] = useState(true);
  const [previousFilter, setPreviousFilter] = useState('');

  const setSelectedFilter = useCallback(
    (fltr: any) => {
      setFilterCount(0);
      setPreviousFilter(filter);
      selectFilter(fltr)
    },
    [selectFilter, setFilterCount, filter],
  )

  return (
    <div className='sound-list-container' style={{ opacity: isLoading ? 0.5: '' }}>
      <div className='sound-list-wrapper'>
      {isLoading && <img src={spinner} className="loading-icon" alt={'loading...'} width={50} height={50} />}
        {showGenre && (<Genre setSelectedFilter={setSelectedFilter} filter={filter} previousFilter={previousFilter} setPreviousFilter={setPreviousFilter} />)}
        <Content filter={filter} filterCount={filterCount} nextValue={''} setShowGenre={setShowGenre} getSongData={getSongData} />
      </div>
      <Footer />
    </div>
  )
}